import React, { Component } from "react";
import { Container, Dimmer, Loader } from "semantic-ui-react";

import ProjectInfo from "./ProjectInfo";
import FilterableDependencyList from "./FilterableDependencyList";

import searchProject from "../libs/searchProject";

const defaultDependencyType = "All";

const dependencyTypes = ["All", "Prod", "Dev", "Opt", "Bundle"];

/**
 * Show filterable project's dependency infomation.
 */
class NpmModulePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      projectExist: false,
      project: {},
      dependencies: []
    };
    this.initPage = this.initPage.bind(this);
  }

  async initPage(pkgName) {
    this.setState({ loading: true });
    try {
      const projectInfo = await searchProject(pkgName);
      this.setState({
        projectExist: true,
        project: projectInfo.project,
        dependencies: projectInfo.dependencies
      });
    } catch (e) {
      this.setState({
        projectExist: false
      });
    }
    this.setState({ loading: false });
  }

  componentWillMount(nextProps) {
    const pkgName = this.props.match.params.pkgName;
    this.initPage(pkgName);
  }

  componentWillReceiveProps(nextProps) {
    const pkgName = nextProps.match.params.pkgName;
    this.initPage(pkgName);
  }

  render() {
    const { loading, projectExist, project, dependencies } = this.state;

    return (
      <Container>
        <Dimmer active={loading}>
          <Loader>Loading</Loader>
        </Dimmer>
        {projectExist ? (
          <div>
            <ProjectInfo project={project} />
            <FilterableDependencyList
              dependencies={dependencies}
              dependencyTypes={dependencyTypes}
              defaultDependencyType={defaultDependencyType}
            />
          </div>
        ) : null}
      </Container>
    );
  }
}

export default NpmModulePage;



// WEBPACK FOOTER //
// ./src/components/NpmModulePage.js